import type { RouteRecordRaw } from 'vue-router'

export const printersRoutes: RouteRecordRaw[] = [
  {
    name: 'printers',
    path: '/printers',
    component: () => import('@/modules/printers/views/PrintersView.vue'),
    meta: {
      locationTypes: ['location', 'singleLocation']
    }
  }
]
